import union from 'lodash/union';

export function tokenToFeildMapping( tokenlist, registrationFieldList ) {

    let tokenFieldTexts = [];
    tokenlist.map(token => {
        if ( token.enabled ) {
            tokenFieldTexts = union( tokenFieldTexts, [ ...token.tokenValue.toLowerCase().replace(/\s/g,'').replace(/dob|birthyear|birthmonth/g,'birthdate').replace(/zip2|zip3|zip5/g,'zipcode').replace(/cellphone/g,'phonenumber').split("+") ]);
        }
    })
    return registrationFieldList.map( field => {
        if ( tokenFieldTexts.includes(field.key.toLowerCase()) ) {
            field.isOptional = "required";
            field.isVisible = true;
            field['requiredForDatavant'] = true;
            if (field.key.toLowerCase() == "gender") {
                field.meta = "standard"
            }
        } else {
            field['requiredForDatavant'] = false;
        }

        //checkif the field dob/birthDate present in token then disable ageRange
        if(field.key.toLowerCase() == 'agerange' && tokenFieldTexts.includes('birthdate')){
            field.isVisible = false;
            field.isOptional = "default";
            field.disableForDatavant = true;
        }
        else if(tokenFieldTexts.includes('birthdate') && (field.key.toLowerCase() == "dobwithmonthyear" || field.key.toLowerCase() == "dobwithyear")){
            field.key = 'birthDate';
            field.isOptional = "required";
            field.isVisible = true;
            field['requiredForDatavant'] = true;
        }else{
            delete field.disableForDatavant;
        }

        return field;
    });
}